import React, { useState, useRef, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ComponentForms from './forms';
import ComponentToolbox from './ComponentToolbox';
import { DraggableComponent } from './DragDrop';
import { ShrinkToFit } from '@bittnerdevelopmentgroup/interactive';
import ErrorBoundary from './ErrorBoundary';
import InteractiveRenderer from './InteractiveRenderer';
const DEBUG = false;
const requestSearch = (components, query) => {
  DEBUG && console.log("search made!!!");
  if (!query || query === "") {
    return components;
  }
  DEBUG && console.log("query is notundef: ", query);
  return components.filter(component => {
    const componentName = component.toLowerCase();
    let included = componentName.includes(query);
    return included;
  });
};
const range = (min, max, step = 1) => {
  let output = [];
  for (let i = min; i < max; i += step) {
    output.push(i);
  }
  return output;
};
const ComponentList = /*#__PURE__*/React.memo(function ComponentList(props) {
  const compListSearched = requestSearch(Object.keys(ComponentToolbox), props.search);
  const [cols, setCols] = useState(0);
  const [cutoffIndices, setCutoffIndices] = useState([]);
  useEffect(() => {
    if (props.toolboxRef.current) {
      const resizeObserver = new ResizeObserver(entries => {
        const entry = entries[0];
        let newCols = Math.min(4, Math.ceil(entry.contentRect.width / 300));
        if (cols !== newCols) {
          setCols(newCols);
          setCutoffIndices(calcCutoffIndices(newCols));
        }
      });
      resizeObserver.observe(props.toolboxRef.current);
    }
  }, [props.toolboxRef]);
  const calcCutoffIndices = newCols => {
    return range(0, compListSearched.length, compListSearched.length / newCols).concat([compListSearched.length]);
  };
  DEBUG && console.log("dragdrop panelLastIndex", props.panelLastIndex, props);
  return /*#__PURE__*/React.createElement(Row, {
    className: "components-scroll"
  }, range(0, cols).map((k, v) => {
    return /*#__PURE__*/React.createElement(Col, {
      xs: true,
      lg: 12 / cols
    }, compListSearched.slice(cutoffIndices[v], cutoffIndices[v + 1]).map((key, i) => {
      return /*#__PURE__*/React.createElement(ComponentListItem, {
        theKey: key,
        parentProps: props
      });
    }));
  }));
});
function ComponentListItem({
  theKey,
  parentProps
}) {
  return /*#__PURE__*/React.createElement(DraggableComponent, {
    key: theKey + "" + parentProps.dropGeneration,
    id: theKey,
    index: parentProps.panelLastIndex,
    className: "toolbox-component" + (theKey === parentProps.selectedComponent ? " selected" : ""),
    onClickCapture: e => {
      e.stopPropagation();
      e.preventDefault();
      parentProps.onClick(theKey);
    },
    onDrop: parentProps.onDrop,
    onDrag: parentProps.onDrag
  }, ComponentToolbox[theKey].type !== "Component" || ComponentForms[ComponentToolbox[theKey].tagName] ? /*#__PURE__*/React.createElement("h2", {
    className: "center"
  }, theKey) : /*#__PURE__*/React.createElement("h2", {
    className: "center text-muted",
    title: "No component form available."
  }, theKey), /*#__PURE__*/React.createElement(ShrinkToFit, {
    style: {
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(InteractiveRenderer, {
    storageKey: theKey,
    data: ComponentToolbox[theKey]
  }))));
}
export default ComponentList;